import { Container, Row, Col } from "react-bootstrap";
import Todays from './Todays';
import Overall from './Overall';
import FilterOrdersPosition from '../FilterOrdersPosition';
import { MARKET_SEGMENT_ID, ORDER_TYPES } from '../../../../../utils/global_variables';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { getScripOrderInfo } from '../../../../../redux/actions/orders';
import { useDispatch } from 'react-redux';


const PositionsContents = ({ positionsActiveTabKey }) => {

    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const dispatch = useDispatch();
    const handlePlaceOrder = () => {
        dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.SINGLE_SCRIP } }));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
        dispatch(getScripOrderInfo(objScrpinfo));
    };
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end

    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col>
                    {
                        positionsActiveTabKey === 'todays' &&
                        <Todays handlePlaceOrder={handlePlaceOrder} />
                    }
                    {
                        positionsActiveTabKey === 'overall' &&
                        <Overall handlePlaceOrder={handlePlaceOrder} />
                    }

                </Col>
            </Row>
            <FilterOrdersPosition />

        </Container>

    );
};

export default PositionsContents;